import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';
import * as Colors from 'material-ui/styles/colors';
import { closeLazyPanel } from 'crazyEditor/redux/modules/panel/panel';
import {PlanAndBilling} from 'MyAccount/AccountPage/AccountPageSectionsData';

const styles = {
  body: {
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    width: 750,
    height: 466,
    minHeight: 466,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
};

@connect(
  (state) => ({
    activeListingsLimit: state.user.planDetails.activeListingsLimit,
    referenceTransactionEnabled: state.user.referenceTransactionEnabled,
  }),
  { closeLazyPanel },
)
export default class LimitReachedDialog extends Component {
  render() {
    const {open, closeLazyPanel, panelName, activeListingsLimit, referenceTransactionEnabled} = this.props;

    return (
      <Dialog
        open={open}
        bodyStyle = {{
          ...styles.body,
        }}
        contentStyle={styles.body}
        onRequestClose = {() => closeLazyPanel(panelName)}
      >
        <IconButton
          onClick={() => closeLazyPanel(panelName)}
          iconStyle={{color: Colors.grey700}}
          style = {{
            position: 'absolute',
            right: 0,
            top: 0,
          }}
        >
          <FontIcon className="material-icons" >close</FontIcon>
        </IconButton>
        <img src={require('./images/upgradeCow.png')}/>
        <div
          style={{width: '80%', marginTop: 30, marginBottom: 30}}
        >
          You've reached your {activeListingsLimit} listings limit.<br/>
          Please upgrade your account.<br/>
          (We need to feed our developers to build awesome features for you!)
        </div>
        <RaisedButton
          label = "change plan"
          primary
          href= {PlanAndBilling.getRoute({referenceTransactionEnabled})}
          target="_blank"
          style = {{
            height: '55px',
            lineHeight: '55px',
          }}
        />
      </Dialog>
    );
  }
}
